import { TFunction } from "i18next";
import { BoundedNameValidationError } from "../../enums/BoundedNameValidationError";
import { BoundedName } from "@pulse/pulse-rpcs/lib/types/boundedName";

interface ValidationErrorType {
  domainName?: BoundedNameValidationError;
  domain?: BoundedNameValidationError;
}

export const getAllowedDomainFieldValidationErrorMessage = (
  t: TFunction,
  validationErrors: ValidationErrorType,
): Record<keyof ValidationErrorType, string | undefined> => {
  const translate = t as unknown as (
    key: string,
    options?: Record<string, unknown>,
  ) => string;

  const getAllowedDomainNameErrorMessage = (
    validationError: BoundedNameValidationError,
  ): string => {
    switch (validationError) {
      case BoundedNameValidationError.MinSize:
        return translate(
          "emailCycles.allowedDomainsNameMinSizeValidationErrorMessage",
        );
      case BoundedNameValidationError.MaxSize:
        return translate(
          "emailCycles.allowedDomainsNameMaxSizeValidationErrorMessage",
          {
            maxSize: BoundedName.constraints.name.maxSize,
          },
        );
      case BoundedNameValidationError.DuplicateName:
        return translate(
          "emailCycles.allowedDomainsDuplicateNameValidationErrorMessage",
        );
      default:
        return validationError satisfies never;
    }
  };

  const getAllowedDomainErrorMessage = (
    validationError: BoundedNameValidationError,
  ): string => {
    switch (validationError) {
      case BoundedNameValidationError.MinSize:
        return translate(
          "emailCycles.allowedDomainsDomainMinSizeValidationErrorMessage",
        );
      case BoundedNameValidationError.MaxSize:
        return translate(
          "emailCycles.allowedDomainsDomainMaxSizeValidationErrorMessage",
          {
            maxSize: BoundedName.constraints.name.maxSize,
          },
        );
      case BoundedNameValidationError.DuplicateName:
        return translate(
          "emailCycles.allowedDomainsDuplicateDomainValidationErrorMessage",
        );
      default:
        return validationError satisfies never;
    }
  };

  return {
    domainName: validationErrors.domainName
      ? getAllowedDomainNameErrorMessage(validationErrors.domainName)
      : undefined,
    domain: validationErrors.domain
      ? getAllowedDomainErrorMessage(validationErrors.domain)
      : undefined,
  };
};
